var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3090",
    "data-name": "Rectangle 3090",
    width: 16,
    height: 16,
    transform: "translate(215 300)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_92",
    "data-name": "Mask Group 92",
    transform: "translate(-215 -300)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(215 301.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M13.143,11.571a2.286,2.286,0,1,1-2.286-2.286A2.286,2.286,0,0,1,13.143,11.571Z",
    transform: "translate(-2.857 -4.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M15.714,5.857H13.607a.519.519,0,0,1-.343-.179l-.926-1.462a.554.554,0,0,0-.049-.066,1.594,1.594,0,0,0-1.218-.579H7.785a1.592,1.592,0,0,0-1.217.579.554.554,0,0,0-.049.066L5.593,5.681a.468.468,0,0,1-.308.179V5.574A.571.571,0,0,0,4.714,5H3.856a.571.571,0,0,0-.571.571V5.86H3.142A1.716,1.716,0,0,0,1.428,7.574v6.855a1.716,1.716,0,0,0,1.714,1.714H15.714a1.716,1.716,0,0,0,1.714-1.714V7.571a1.716,1.716,0,0,0-1.714-1.714Zm-6.286,8a3.429,3.429,0,1,1,3.429-3.429,3.429,3.429,0,0,1-3.429,3.429Z",
    transform: "translate(-1.428 -3.571)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.5b53b7c477c43eb00128c2d81945c3e7.svg";
export { ForwardRef as ReactComponent };